<template>
  <div >
    <!--<div style="height: 4.5rem;">
    </div>-->
    <app-header v-if="header_show"></app-header>
    <div class="container">
      <ul style="border-radius: 0.3rem;margin-top: 1rem;">
        <li>
          <p>开户户名</p>
          <input type="text" ref="yh_hm" autocomplete="off" readonly="true" value=""/>
        </li>
        <li>
          <p>开户人身份证</p>
          <input type="text" ref="aac002" autocomplete="off" readonly="true"   placeholder="请填写您的身份证号" value=""/>
        </li>
        <li>
          <p>开户银行名称</p>
          <input type="text" ref="yh_mc" autocomplete="off" placeholder="请填写您的开户银行名称" />
        </li>
        <p style="color: red;font-size: 0.9rem;margin-left: 1.2rem;">银行名称格式:&nbsp;&nbsp;&nbsp;**行**省**市**区(路)**分理处(支行)</p>
        <li>
          <p>银行卡号/存折账号</p>
          <input type="number" ref="yh_kh" autocomplete="off" placeholder="请填写银行卡号/存折账号"/>
        </li>
        <li>
          <p>座机电话</p>
          <input type="number" ref="aae005" autocomplete="off" placeholder="请填写您的座机号码"/>
        </li>
        <p style="color: red;font-size: 0.9rem;margin-left: 1.2rem;">在职职工请填写您的办公电话</p>
      </ul>
      <p class="p_lin">身份证原件 &nbsp;
        <span style="color: #3485fa">(点击+号进行添加上传)</span>
      </p>
      <div class="sfzImgDiv" style="margin-top: 3%">
        <div class="b-left"></div>
        <div class="b-box-img" v-for="(item,index) in sfzImgList">
          <div class="img_back div_click" @click="chooseImage('sfz', index, item.type)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <p class="p_lin">银行卡/存折主页照片 &nbsp;
        <span style="color: #3485fa">(点击+号进行添加上传)</span>
      </p>
      <div class="yhkImgDiv" style="margin-top: 3%">
        <div class="b-left"></div>
        <div class="b-box-img" v-for="(item,index) in yhkImgList">
          <div class="img_back div_click" @click="chooseImage('yhk', index, item.type)">
            <img class="img_all yhk" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div>
        <div style="margin-top: 5%">
          <span class="p_lin" >电子/纸质发票 &nbsp;</span>
          <span style="color: #3485fa">(点击+号进行添加上传)</span>
        </div>
        <div style="margin-left: 5%;margin-top: 0.5rem">
          <span class="linkBtn" @click="showPopup('ZYZZ')">财政纸质发票</span>
          <span class="linkBtn" @click="showPopup('ZYDZ')">财政电子发票</span>
        </div>
      </div>
      <div class="dzfpImgDiv" style="margin-top: 4%">
        <!--<div class="b-left"></div>-->
        <div class="b-box-img" v-for="(item,index) in dzfpImgList">
          <div class="img_back div_click" @click="chooseImage('dzfp', index, item.type)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div>
        <div style="margin-top: 5%">
          <span class="p_lin" >附件1 &nbsp;</span>
          <span style="color: #3485fa">(点击+号进行添加上传)</span>
        </div>
        <div style="margin-left: 5%;margin-top: 0.5rem;color: #3485fa">
          出院证（或出院小结或出院记录）、病情诊断书
        </div>
      </div>
      <div class="dzfpImgDiv" style="margin-top: 4%">
        <!--<div class="b-left"></div>-->
        <div class="b-box-img" v-for="(item,index) in fjImgList1">
          <div class="img_back div_click" @click="chooseImage('fj1', index, item.type)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div>
        <div style="margin-top: 5%">
          <span class="p_lin" >附件2 &nbsp;</span>
          <span style="color: #3485fa">(点击+号进行添加上传)</span>
        </div>
        <div style="margin-left: 5%;margin-top: 0.5rem;color: #3485fa">
          住院分类汇总明细清单
        </div>
      </div>
      <div class="dzfpImgDiv" style="margin-top: 4%">
        <!--<div class="b-left"></div>-->
        <div class="b-box-img" v-for="(item,index) in fjImgList2">
          <div class="img_back div_click" @click="chooseImage('fj2', index, item.type)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <p class="p_lin" style="margin-top: 5%;color: rgb(233, 104, 107);padding-right: 5%;">提示：
        <span style="color: #3485fa;font-size: 0.9rem;color: rgb(233, 104, 107)">若上传图片有误，请点击图片，重新上传替换原图片！</span>
      </p>
      <div class="lastDiv">
        <button :class="cannotSubmit===true ? 'submit_btn submit_btn_gray' : 'submit_btn'" @click="allSubmit" :disabled="cannotSubmit">提&nbsp;&nbsp;&nbsp;&nbsp;交</button>
        <!--<button class="continue_btn" @click="newBusiness">继续办理</button>-->
      </div>
    </div>
    <mt-actionsheet
      :actions="downActions"
      v-model="sheetVisible">
    </mt-actionsheet>
    <mt-popup
      v-model="popupFP1"
      popup-transition="popup-fade">
      <div class="popupDiv">
        <img style="width: 500px;height:400px;" src="../../../static/img/wsbx_zyzzfp.jpg">
      </div>
    </mt-popup>
    <mt-popup
      v-model="popupFP2"
      popup-transition="popup-fade">
      <div class="popupDiv">
        <img style="width: 500px;height:400px;" src="../../../static/img/wsbx_zydzfp.jpg">
      </div>
    </mt-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import header from '@/components/header/header.vue'
import wx from 'weixin-js-sdk'
import {Indicator, MessageBox, Actionsheet} from 'mint-ui'
Vue.component(Actionsheet.name, Actionsheet)
export default {
  components: {
    'app-header': header
  },
  data () {
    return {
      header_show: true, // true和false控制头部显示或者不显示
      tempImgUrl: require('../../assets/images/wsbx/ywbl_146.png'),
      sfzImgList: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '正面', type: 'temp'},
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '反面', type: 'temp'}
      ],
      yhkImgList: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      dzfpImgList: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      fjImgList1: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      fjImgList2: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      downActions: [
        {name: '查看大图', method: this.previewImg},
        {name: '更换图片', method: this.changeImg},
        {name: '删除图片', method: this.deleteImg}
      ],
      sheetVisible: false,
      selectedImg: {},
      cannotSubmit: false,
      alreadySubmit: false,
      popupFP1: false,
      popupFP2: false
    }
  },
  mounted () {
    this.$refs.yh_hm.value = localStorage.getItem('aac003')
    this.$refs.aac002.value = localStorage.getItem('aac002')
    // 获取银行卡号
    this.getBankNo()
    this.wxConfig()
  },
  methods: {
    // 微信js初始化
    wxConfig () {
      Indicator.open({
        text: '微信接口初始化...',
        spinnerType: 'fading-circle'
      })
      var params = new URLSearchParams()
      var signUrl = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.entryUrl
      params.append('url', signUrl)
      this.$http.post('/api/weJSsdkSign', params).then((res) => {
        console.log(res)
        Indicator.close()
        wx.config({
          debug: false, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ['config', 'hideMenuItems', 'chooseImage', 'uploadImage', 'getLocalImgData', 'updateTimelineShareData',
            'downloadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function () {
          // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
          wx.hideMenuItems({
            menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone',
              'menuItem:editTag', 'menuItem:delete', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:readMode', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
          })
        })
        wx.error(function (res) {
          MessageBox.alert('微信环境配置失败!')
        })
      })
    },
    // 选择图片
    chooseImage (type, index, imgType, optype) {
      let that = this
      if (imgType === 'temp') {
        // alert(type + '----' + index)
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            var localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            that.uploadImg(type, index, localIds, optype)
          }
        })
      } else if (imgType === 'upload') {
        if (type === 'sfz') {
          this.selectedImg = {'type': type, 'index': index, 'url': this.sfzImgList[index].url, status: 'upload'}
        } else if (type === 'dzfp') {
          this.selectedImg = {'type': type, 'index': index, 'url': this.dzfpImgList[index].url, status: 'upload'}
        } else if (type === 'yhk') {
          this.selectedImg = {'type': type, 'index': index, 'url': this.yhkImgList[index].url, status: 'upload'}
        } else if (type === 'fj1') {
          this.selectedImg = {'type': type, 'index': index, 'url': this.fjImgList1[index].url, status: 'upload'}
        } else if (type === 'fj2') {
          this.selectedImg = {'type': type, 'index': index, 'url': this.fjImgList2[index].url, status: 'upload'}
        }
        this.sheetVisible = !this.sheetVisible
      }
    },
    uploadImg (type, index, localIds, optype) { // 上传成功，微信服务器会返回一个本地ID，可以预览
      var that = this
      wx.getLocalImgData({// 根据本地ID获得微信服务器ID
        localId: localIds[0].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function (res) {
          var localData = res.localData // localData是图片的base64数据，可以用img标签显示
          localData = localData.replace('jgp', 'jpeg')// iOS 系统里面得到的数据，类型为 image/jgp,因此需要替换一下
          Indicator.open({
            text: '图片上传中...',
            spinnerType: 'fading-circle'
          })
          wx.uploadImage({// 根据本地ID获得微信服务器ID
            localId: localIds[0].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res) {
              var serverId = res.serverId // 返回图片的服务器端ID
              var params = new URLSearchParams()
              params.append('mediaId', serverId)
              that.$http.post('/api/kxcwx/wxUcmupload', params).then(res => {
                Indicator.close()
                if (res.data.code === '1') {
                  if (type === 'sfz') {
                    that.sfzImgList.splice(index, 1, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                  } else if (type === 'dzfp') {
                    if (optype && optype === 'change') {
                      that.dzfpImgList.splice(index, 1, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                    } else {
                      that.dzfpImgList.splice(that.dzfpImgList.length - 1, 0, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                    }
                  } else if (type === 'yhk') {
                    that.yhkImgList.splice(index, 1, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                  } else if (type === 'fj1') {
                    if (optype && optype === 'change') {
                      that.fjImgList1.splice(index, 1, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                    } else {
                      that.fjImgList1.splice(that.fjImgList1.length - 1, 0, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                    }
                  } else if (type === 'fj2') {
                    if (optype && optype === 'change') {
                      that.fjImgList2.splice(index, 1, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                    } else {
                      that.fjImgList2.splice(that.fjImgList2.length - 1, 0, {url: /(Android)/i.test(navigator.userAgent) ? localIds[0] : localData, title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                    }
                  }
                } else {
                  MessageBox.alert(res.data.message)
                }
              }).catch(err => {
                Indicator.close()
                MessageBox.alert(err)
              })
            }
          })
        }
      })
    },
    /* uploadImg (type, index, localIds, optype) { // 上传成功，微信服务器会返回一个本地ID，可以预览
      var that = this
      wx.uploadImage({// 根据本地ID获得微信服务器ID
        localId: localIds[0].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function (res) {
          var serverId = res.serverId // 返回图片的服务器端ID
          // alert('serverId' + serverId)
          Indicator.open({
            text: '图片上传中...',
            spinnerType: 'fading-circle'
          })
          var params = new URLSearchParams()
          params.append('mediaId', serverId)
          that.$axios.post('/api/kxcwx/wxUcmupload', params).then(res => {
            Indicator.close()
            if (res.data.code === '1') {
              if (type === 'sfz') {
                that.sfzImgList.splice(index, 1, {url: localIds[0], title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
              } else if (type === 'dzfp') {
                if (optype && optype === 'change') {
                  that.dzfpImgList.splice(index, 1, {url: localIds[0], title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                } else {
                  that.dzfpImgList.splice(that.dzfpImgList.length - 1, 0, {url: localIds[0], title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
                }
              } else if (type === 'yhk') {
                that.yhkImgList.splice(index, 1, {url: localIds[0], title: '', type: 'upload', fileid: res.data.fileid, filename: res.data.filename})
              }
            } else {
              MessageBox.alert(res.data.message)
            }
          }).catch(err => {
            Indicator.close()
            MessageBox.alert(err)
          })
        }
      })
    }, */
    // 预览图片
    previewImg () {
      this.sheetVisible = !this.sheetVisible
      let urls = []
      let url = this.selectedImg.url
      urls.push(url)
      wx.previewImage({
        current: url,
        urls: urls
      })
    },
    // 更换图片
    changeImg () {
      this.sheetVisible = !this.sheetVisible
      this.chooseImage(this.selectedImg.type, this.selectedImg.index, 'temp', 'change')
    },
    // 删除图片
    deleteImg () {
      this.sheetVisible = !this.sheetVisible
      if (this.selectedImg.type === 'sfz') {
        let title = this.selectedImg.index === 0 ? '正面' : '反面'
        this.sfzImgList.splice(this.selectedImg.index, 1, {url: this.tempImgUrl, title: title, type: 'temp'})
      } else if (this.selectedImg.type === 'dzfp') {
        this.dzfpImgList.splice(this.selectedImg.index, 1)
      } else if (this.selectedImg.type === 'yhk') {
        let title = '上传'
        this.yhkImgList.splice(this.selectedImg.index, 1, {url: this.tempImgUrl, title: title, type: 'temp'})
      } else if (this.selectedImg.type === 'fj1') {
        this.fjImgList1.splice(this.selectedImg.index, 1)
      } else if (this.selectedImg.type === 'fj2') {
        this.fjImgList2.splice(this.selectedImg.index, 1)
      }
    },
    // 提交确认
    confirmSubmit () {

    },
    // 提交
    allSubmit () {
      let that = this
      this.cannotSubmit = true
      let yh_hm = this.$refs.yh_hm.value
      let aac002 = this.$refs.aac002.value
      let yh_mc = this.$refs.yh_mc.value
      let yh_kh = this.$refs.yh_kh.value
      let aae005 = this.$refs.aae005.value
      if (yh_hm === '') {
        MessageBox.alert('请填写用户名')
        this.cannotSubmit = false
        return
      }
      if (aac002 === '') {
        MessageBox.alert('请填写身份证号码')
        this.cannotSubmit = false
        return
      }
      if (yh_mc === '') {
        MessageBox.alert('请填写开户银行名称')
        this.cannotSubmit = false
        return
      }
      if (yh_kh === '') {
        MessageBox.alert('请填写银行卡/存折号码')
        this.cannotSubmit = false
        return
      }
      /* if (aae005 === '') {
        MessageBox.alert('请填写座机电话号码')
        this.cannotSubmit = false
        return
      } */
      let imglist = [] // 身份证正面、身份证反面；银行卡或存折
      let imglist1 = [] // 电子发票或纸质发票
      let imglist2 = [] // 账户报销：附件；住院、门诊：附件1
      let imglist3 = [] // 门诊、住院：附件2
      // 身份证是否上传
      for (let i = 0; i < this.sfzImgList.length; i++) {
        if (this.sfzImgList[i].type === 'temp') {
          MessageBox.alert('请上传身份证' + this.sfzImgList[i].title + '照片!')
          this.cannotSubmit = false
          return
        } else {
          imglist.push({'fileid': this.sfzImgList[i].fileid, 'filename': this.sfzImgList[i].filename})
        }
      }
      // 银行卡是否上传
      for (let i = 0; i < this.yhkImgList.length; i++) {
        if (this.yhkImgList[i].type === 'temp') {
          MessageBox.alert('请上传银行卡/存折照片!')
          this.cannotSubmit = false
          return
        } else {
          imglist.push({'fileid': this.yhkImgList[i].fileid, 'filename': this.yhkImgList[i].filename})
        }
      }
      // 电子发票是否上传
      if (this.dzfpImgList.length === 1) {
        MessageBox.alert('请上传电子发票照片!')
        this.cannotSubmit = false
        return
      } else {
        for (let i = 0; i < this.dzfpImgList.length - 1; i++) {
          imglist1.push({'fileid': this.dzfpImgList[i].fileid, 'filename': this.dzfpImgList[i].filename})
        }
      }
      // 附件是否上传
      for (let i = 0; i < this.fjImgList1.length - 1; i++) {
        imglist2.push({'fileid': this.fjImgList1[i].fileid, 'filename': this.fjImgList1[i].filename})
      }
      for (let i = 0; i < this.fjImgList2.length - 1; i++) {
        imglist3.push({'fileid': this.fjImgList2[i].fileid, 'filename': this.fjImgList2[i].filename})
      }
      // // 提示报销金额不能大于账户余额
      // MessageBox.confirm('', {
      //   message: '请仔细核对发票金额，确保报销总金额不大于个人账户余额,否则将无法报销!',
      //   title: '温馨提示'
      // }).then(action => {
      //   if (action === 'confirm') {
      var params = new URLSearchParams()
      params.append('jybh', 'kxc_control')
      params.append('asr_jyh', 'wsjb_gzbxsq')
      params.append('aac001', localStorage.getItem('aac001'))
      params.append('aac003', localStorage.getItem('aac003'))
      params.append('aac002', localStorage.getItem('aac002'))
      params.append('aab001', localStorage.getItem('aab001'))
      params.append('aab004', localStorage.getItem('aab004'))
      params.append('yae005', localStorage.getItem('yae005'))// 手机号
      params.append('yka130', '03')// 01个人账户  02门诊  03住院
      params.append('yae001', '00')// 业务办理状态
      params.append('bae135', '02')// 01app,02微信
      params.append('aae010', yh_kh)
      params.append('aae008', yh_mc)
      params.append('aae005', aae005) // 座机号码
      params.append('imglist', JSON.stringify(imglist))
      params.append('imglist1', JSON.stringify(imglist1))
      params.append('imglist2', JSON.stringify(imglist2))
      params.append('imglist3', JSON.stringify(imglist3))
      this.$http.post('/api/kxcwx/saveDeclare', params).then(res => {
        if (res.data.code === '1') {
          MessageBox.alert('网上报销提交成功!可在查询界面查询业务办理状态。如需再次申报，请点击【继续办理】。')
          that.alreadySubmit = true
          this.$router.push('/wsbx')
        } else {
          MessageBox.alert('提交失败!' + res.data.message)
          that.cannotSubmit = false
        }
      })
      //   } else {
      //     that.cannotSubmit = false
      //   }
      // }).catch(err => {
      //   if (err === 'cancel') {
      //     console.log('cancel')
      //     that.cannotSubmit = false
      //   }
      // })
    },
    // 继续办理
    newBusiness () {
      let that = this
      if (this.alreadySubmit === false) {
        MessageBox.confirm('', {
          message: '您还有未提交的数据!确定刷新页面吗?',
          title: '警告'
        }).then(action => {
          if (action === 'confirm') {
            that.clearData()
          }
        }).catch(err => {
          if (err === 'cancel') {
            console.log('cancel')
          }
        })
      } else {
        that.clearData()
      }
    },
    showPopup (type) {
      if (type === 'ZYZZ') {
        this.popupFP1 = true
      } else if (type === 'ZYDZ') {
        this.popupFP2 = true
      }
    },
    clearData () {
      this.sfzImgList = [
        {url: this.tempImgUrl, title: '正面', type: 'temp'},
        {url: this.tempImgUrl, title: '反面', type: 'temp'}
      ]
      this.yhkImgList = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.dzfpImgList = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.fjImgList1 = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.fjImgList2 = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.sheetVisible = false
      this.selectedImg = {}
      this.cannotSubmit = false
      this.alreadySubmit = false
      this.popupFP1 = false
      this.popupFP2 = false
    },
    dealSFZH (aac002) {
      if (aac002.length === 18) {
        return aac002.substr(0, 3) + '***********' + aac002.substr(14)
      } else {
        return aac002.substr(0, 3) + '********' + aac002.substr(11)
      }
    },
    getBankNo () {
      var aac001 = localStorage.getItem('aac001')
      var params = new URLSearchParams()
      params.append('jybh', 'KXCCX020')
      params.append('aac001', aac001)
      params.append('aac002', localStorage.getItem('aac002'))
      params.append('access_token', localStorage.getItem('access_token'))
      this.$http.post('/api/kxcwx/queryData', params).then(res => {
        if (res.data.code === '1') {
          // console.log(res.data)
          var output = res.data.output
          if (output.length > 0) {
            this.$refs.yh_kh.value = output[0].aae010
            this.$refs.yh_mc.value = output[0].aae008
          }
        } else {
          /* MessageBox.alert('查询银行卡号失败!' + res.data.message) */
        }
      })
    }

  },
  beforeRouteEnter (to, from, next) {
    /* var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    } */
    next()
  },
  beforeRouteLeave (to, form, next) {
    /* alert('bbbbbbllleave')
      MessageBox.confirm('Are you sure?').then(action => {
       alert('曲儿')
       next()
     }, action => {
       alert('区县')
     }) */
    next()
  }

}
</script>
<style scoped>
   @import '../../../static/css/wsbx_sb.css';
  .dzfpImgDiv{
    width: 88%;
    margin-left: 4%;
    padding-left: 4%;
    padding-top: 2rem;
    padding-bottom: 2rem;
    /*height: 15rem;*/
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    /*justify-content:center;*/
    border: 1px dashed #3485FA;
    border-radius: 0.8rem;
  }
   .linkBtn{
     text-align: center;
     background-color: #3485FA;
     margin: auto;
     border-radius: 0.3rem;
     color: #ffffff;
     font-size: 0.9rem;
     padding: 0.2rem;
     margin-right: 0.5rem;
     margin-top: 0.5rem;
   }
   .popupDiv{
     height: 50vh;
     width: 90vw;
     color: #3485fa;
     overflow: auto;
   }
</style>



// WEBPACK FOOTER //
// src/project/ywbl/wsbx_sb_zy.vue